import { render, staticRenderFns } from "./country-selection.vue?vue&type=template&id=0ec2aec3&"
import script from "./country-selection.vue?vue&type=script&lang=ts&"
export * from "./country-selection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports